var render, staticRenderFns
import script from "./Home.vue?vue&type=script&lang=tsx"
export * from "./Home.vue?vue&type=script&lang=tsx"
import style0 from "./Home.vue?vue&type=style&index=0&id=00016cfa&prod&lang=scss&scoped=true"
import style1 from "./Home.vue?vue&type=style&index=1&id=00016cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00016cfa",
  null
  
)

export default component.exports